import { t } from "@lingui/core/macro";

export const getMessage = (key) => {
  const messages = {
    account_setup_success: t`Completion of account setup was successful.`,
    account_setup_failure: t`Completion of account setup failed.`,
    email_checking: t`Checking email availability.`,
    email_found: t`Email is found.`,
    shared_code_needed: t`Email is not found, needs shared secret.`,
    email_check_failure: t`Check email availability failure.`,
    reg_code_checking: t`Checking registration code.`,
    reg_code_verified: t`Registration code verified.`,
    reg_code_failure: t`Check registration code failure.`,
    member_id_checking: t`Checking member id.`,
    member_id_success: t`Member id verified.`,
    member_id_failure: t`Check member id failure.`,
    member_registering: t`Registering member.`,
    member_create_success: t`Successfully created member.`,
    member_create_failure: t`Failed to create member.`,
    signing_in: t`Signing in.`,
    signin_success: t`Successfully signed in.`,
    signin_failure: t`Failed to sign in.`,
    signing_out: t`Signing out.`,
    signout_success: t`Successfully signed out.`,
    signout_failure: t`Failed to sign out.`,
    session_validating: t`Validating existing session.`,
    session_valid: t`Session is valid.`,
    session_invalid: t`Session is not valid.`,
    member_account_load_failure: t`Unable to retrieve member account info`,
    member_account_failure: t`Unable to save member account info`,
    member_complete_profile: t`Completing member profile.`,
    member_complete_success: t`Successfully completed member.`,
    member_complete_failure: t`Failed to complete member.`,
    member_location_failure: t`Unable to retrieve member location`,
  };

  return messages[key] || null;
};
